import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import Nav from '../AppNav/VerticalNavWrapper';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import PerfectScrollbar from 'react-perfect-scrollbar';
import HeaderLogo from '../AppLogo';
import {
  setEnableMobileMenuViewRevise
} from '../../Reducers/ThemeOptions';
import { api } from "../../api/api";

class AppSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navMenulist: []
    }
  }

  toggleMobileSidebar = () => {
    let { enableMobileMenuView, setEnableMobileMenuViewRevise } = this.props;
    setEnableMobileMenuViewRevise(!enableMobileMenuView);
  }

  componentDidMount() {
    // if(localStorage.getItem('webqMenuConfig') === null){
    //   this.getAccessControlPages();
    // } else {
    //   this.setState({
    //     navMenulist : localStorage.getItem('webqMenuConfig')
    //   });
    // }
  }

  getAccessControlPages() {
    let menuConfigUrl = 'rolepage/';
    api.get(menuConfigUrl).then(menuResult => {
      let pageNames;
      let updatePages = [];
      menuResult.data.map((accessControlPages) => {
        updatePages.push(accessControlPages['pageName']);
      });

      if (updatePages.length > 0) {
        pageNames = [...new Set(updatePages)];
      }
      localStorage.setItem('webqMenuConfig', pageNames?.toString());

      this.setState(
        {
          navMenulist: pageNames?.toString(),
          isPending: false,
          hasError: false
        }
      );
    });
  }

  render() {
    let { backgroundColor, enableBackgroundImage, enableSidebarShadow, backgroundImage, backgroundImageOpacity } = this.props;
    return (
      <Fragment>
        <div className="sidebar-mobile-overlay" onClick={this.toggleMobileSidebar} />
        <ReactCSSTransitionGroup
          component="div"
          className={cx("app-sidebar", backgroundColor, { 'sidebar-shadow': enableSidebarShadow })}
          transitionName="SidebarAnimation"
          transitionAppear={true}
          transitionAppearTimeout={1500}
          transitionEnter={false}
          transitionLeave={false}>
          <HeaderLogo />
          <PerfectScrollbar>
            {/* {
                        (
                          localStorage.getItem('webqMenuConfig') !== null &&
                          localStorage.getItem('webqMenuConfig') !== undefined &&
                          localStorage.getItem('webqMenuConfig') !== ''
                        ) && */}
            <div className="app-sidebar__inner">
              <Nav navMenulist={this.state.navMenulist} />
            </div>
            {/* } */}

          </PerfectScrollbar>
          <div
            className={cx("app-sidebar-bg", backgroundImageOpacity)}
            style={{
              backgroundImage: enableBackgroundImage ? 'url(' + backgroundImage + ')' : null
            }}>
          </div>
        </ReactCSSTransitionGroup>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  enableBackgroundImage: state.ThemeOptions.enableBackgroundImage,
  enableSidebarShadow: state.ThemeOptions.enableSidebarShadow,
  enableMobileMenuView: state.ThemeOptions.enableMobileMenuView,
  backgroundColor: state.ThemeOptions.backgroundColor,
  backgroundImage: state.ThemeOptions.backgroundImage,
  backgroundImageOpacity: state.ThemeOptions.backgroundImageOpacity,
});

const mapDispatchToProps = dispatch => ({

  setEnableMobileMenuViewRevise: enable => dispatch(setEnableMobileMenuViewRevise(enable)),

});

export default connect(mapStateToProps, mapDispatchToProps)(AppSidebar);